import { Maybe, User } from '../../common/types'
import { createContext, useContext } from 'react'
import styled from 'styled-components'
import { TowingOrderFilters } from '../../functions/graphqlApi/types/towingOrder'

export type TowingJobStatus = 'ALL' | 'COMPLETED' | 'OPEN'

export type QueryValues = {
  filters: TowingOrderFilters
  status: TowingJobStatus
  search: string
  userId: Maybe<number>
}

export const initialValues: QueryValues = {
  userId: null,
  filters: {
    includeTowingRecords: true,
    includeTowingOrders: true,
    stations: [],
    labels: [],
    visibility: [],
    operators: [],
    hidePreOrders: false,
    jobDayFilters: [],
    priorityTag: [],
  },
  status: 'OPEN',
  search: '',
}

export interface TowingJobFilterContext {
  values: QueryValues
  initialValues: Readonly<QueryValues>
  currentUser: User
  resetToDefaultOptions: () => void
  setValues: (values: QueryValues) => void
  loading: boolean
  isDefaultModified: boolean
}

const TowingJobFilterContextInstance = createContext<Maybe<TowingJobFilterContext>>(null)

export const TowingJobFilterProvider = TowingJobFilterContextInstance.Provider

export const useTowingJobFilterContext = (): TowingJobFilterContext => {
  const context = useContext(TowingJobFilterContextInstance)
  if (!context) {
    throw new Error('useTowingJobFilterContext must be used within a TowingJobFilterProvider')
  }
  return context
}

export const SelectContainer = styled.div`
  margin: 0.25rem 0 0 0;
`
